import {
  createAsyncThunk,
  createSlice,
  injectSlice,
} from '@bonanza-social/toolkit/state';
import RewardsService from '../services/RewardsService';
import { RewardsState } from './rewards.types';
import { mergeFreeSpins } from '../utils/mergeFreeSpins';
import { appLogout } from '@bonanza-social/toolkit/state';

export const fetchFreeSpins = createAsyncThunk('freeSpins/fetch', async () => {
  const res = await RewardsService.getFreeSpins();

  return res;
});

const initialState: RewardsState = {
  freeSpins: {
    data: [],
    dataState: 'idle',
  },
};

const rewards = createSlice({
  name: 'rewards',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchFreeSpins.pending, (state) => {
      if (state.freeSpins.dataState === 'fulfilled') {
        state.freeSpins.dataState = 'refreshing';
      } else {
        state.freeSpins.dataState = 'pending';
      }
    });

    builder.addCase(fetchFreeSpins.rejected, (state) => {
      state.freeSpins.dataState = 'rejected';
    });

    builder.addCase(fetchFreeSpins.fulfilled, (state, action) => {
      state.freeSpins.data = mergeFreeSpins(action.payload);
      state.freeSpins.dataState = 'fulfilled';
    });
    builder.addCase(appLogout, () => {
      return initialState;
    });
  },
});

export const withRewards = injectSlice({
  reducerPath: 'rewards',
  reducer: rewards.reducer,
});

export const selectFreeSpinsDataState = withRewards.selector(
  (state) => state.rewards.freeSpins.dataState,
);

export const selectFreeSpins = withRewards.selector(
  (state) => state.rewards.freeSpins.data,
);

declare global {
  interface LazyLoadedSlices {
    rewards: ReturnType<typeof rewards.reducer>;
  }
}
